exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".containerTitle{\n  font-size:60px;\n  font-weight: 900;\n}\n.resumeContainer{\n  padding: 15rem 20px;\n  margin: 5rem 0;\n  color: white;\n}\n.resumeContainer h2{\n    font-size: 40px;\n    font-weight: 700;\n    color: rgba(216, 88, 86, 0.7);\n}\n.resumeContainer h5{\n    clear: both;\n}\n.resumeContainer p{\n    font-weight: 200;\n}\n.logo {\n    max-width: 66px;\n    max-height: 66px;\n    float: left;\n    margin-right: 22px;\n}\n.resumeItem{\n    margin: 30px 0;\n}\n.resumeDownload {\n    background-color: rgba(216, 88, 86, 0.7);\n    color: white;\n    padding: 10px;\n    border-radius: 7px;\n    font-weight: 900;\n    border: 0px solid black;\n}\n.resumeDownload:hover {\n    background-color: rgba(119, 34, 32, 0.7);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/app/resume/resume.component.css
// module id = ../../../../../src/app/resume/resume.component.css
// module chunks = main